import {
  AdminInventoryItem,
  InventoryItem,
  OwnerInventoryItem,
  OwnerInventoryPage,
} from '@lib/types';

import {
  CardPrintingDTO,
  SimplifiedCardDTO,
  createCardPrinting,
  createSimplifiedCard,
} from '../catalog/models';

export interface InventoryItemDTO {
  id: string;
  printing: CardPrintingDTO & { card: SimplifiedCardDTO };
  language: InventoryItem['language'];
  condition: InventoryItem['condition'];
  edition: InventoryItem['edition'];
  observation: string | null;
  quantity: number;
  price: string;
  originalPrice?: string;
  originalPriceCents?: number;
  effectivePriceCents?: number;
  promotionEndsAt?: string;
  active: boolean;
}

export interface OwnerInventoryItemDTO extends InventoryItemDTO {
  createdAt: string;
  updatedAt: string;
}

export interface OwnerInventoryPageDTO {
  items: OwnerInventoryItemDTO[];
  nextCursor?: string;
  totalItems: number;
}

export interface AdminInventoryItemDTO extends OwnerInventoryItemDTO {
  store: AdminInventoryItem['store'];
}

export const createInventoryItem = (dto: InventoryItemDTO): InventoryItem => ({
  id: dto.id,
  printing: {
    ...createCardPrinting(dto.printing),
    card: createSimplifiedCard(dto.printing.card),
  },
  language: { ...dto.language },
  condition: dto.condition,
  edition: dto.edition,
  observation: dto.observation,
  quantity: dto.quantity,
  price: dto.price,
  originalPrice: dto.originalPrice,
  originalPriceCents: dto.originalPriceCents,
  effectivePriceCents: dto.effectivePriceCents,
  promotionEndsAt: dto.promotionEndsAt,
  active: dto.active,
});

export const createOwnerInventoryItem = (
  dto: OwnerInventoryItemDTO,
): OwnerInventoryItem => ({
  ...createInventoryItem(dto),
  active: dto.active,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
});

export const createOwnerInventoryPage = (
  dto: OwnerInventoryPageDTO,
): OwnerInventoryPage => ({
  items: dto.items.map(createOwnerInventoryItem),
  nextCursor: dto.nextCursor,
  totalItems: dto.totalItems,
});

export const createAdminInventoryItem = (
  dto: AdminInventoryItemDTO,
): AdminInventoryItem => ({
  ...createOwnerInventoryItem(dto),
  store: { ...dto.store },
});

export const createInventoryItems = (items: InventoryItemDTO[]) =>
  items.map(createInventoryItem);
